import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref, watch } from '../../../../adapter-vue';
import Icon from "../../../common/Icon.vue";
import voice from "../../../../assets/icon/voice.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-audio',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



const data = ref();
const message = ref();
const show = ref();
const audioRef = ref(null);

watchEffect(() => {
  message.value = props.messageItem;
  data.value = props.content;
});

const play = () => {
  const audios = document.getElementsByTagName('audio');
  for (const audio of audios) {
    if (!audio.paused) {
      audio.pause();
      audio.load();
    }
  }
  const audioPlayer: any = audioRef.value;
  if (audioPlayer.paused) {
    audioPlayer.play();
    show.value = true;
  } else {
    audioPlayer.pause();
    audioPlayer.load();
    show.value = false;
  }
};

return { __sfc: true,props, data, message, show, audioRef, play, Icon, voice }
}

})